/**
 * Gestion des tags sur la liste des actualités
 */ 
var ajaxPending = false;

// On bloque la hauteur du contenu pour éviter des sauts de page
$('#home-content').css('min-height', $('#home-content').height());

// Clics sur les badges
$('.blog__tags-list').on('click', 'button.badge', function(event) {
    if(!ajaxPending) {
        $(this).toggleClass('active');
        
        refreshPosts();
    } 
});

// Chargement des nouveaux articles (selon les badges)
function refreshPosts() {
    var tags = $('.blog__tags-list .badge.active').map(function(index, elem) { return $(elem).val(); }).get();

    updateURL(tags);

    $.ajax({
        url: ajaxurl,
        data: {
            action: "newsWithTags",
            tags: tags
        },
        beforeSend: function() {
            ajaxPending = true;
            $('#home-content').empty();
        },
    }) 
    .done(function(data) {
        $('#home-content').html(data);

        if(window.scrollInView != undefined) {
            window.scrollInView.reload($('#home-content').find('.scroll-in-view'));
        }
    })
    .fail(function(data) {
    })
    .always(function(data) {
        ajaxPending = false;
    });
}
 
// Mise à jour de l'URL
function updateURL(tags) {
    var params = new URLSearchParams(window.location.search);
    
    params.delete('tags[]');

    if(tags.length) {
        for(t of tags) {
            params.append('tags[]', t); 
        }
    }

    if(params.toString().length) {
        history.pushState(null, null, '?' + params.toString());
    }
    else {
        history.replaceState({}, '', './');
    }
}